// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2MV9TuGkNu3Q2ZguqRENLb","Header":"_2EGthnd8IJzJ1nt3pdtR3B","Content":"_15RxDjY_4cN2AZ0krIkt87","Button":"_3JoNiUcbC1pRhBvpBtA8Xa","Empty":"_14ZxbGNxg4ElMXbhLt6lJg","EmptyText":"_1-K18JPa84zbHnihzbwJWb"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/EventsWidget/styles.module.css
// module id = 200
// module chunks = 0